import React from 'react';
import './App.css';
import { useRef, useEffect, useState, useCallback } from 'react';
import { API } from 'aws-amplify';
import Plot from 'react-plotly.js';
import { Slider, CircularProgress } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import * as mm from "@magenta/music";

const myAPI = 'tashinamgyal';
const path = '/lambdadocker';


export default function MidiDraw() {

    const EMPTY = {notes: [], totalTime: 8, controlChanges: []}

    const canvasHeight = 200;
    const canvasWidth = 500;

    const drawRef = useRef(null);
    const rollRef = useRef(null);
    const sliderRef = useRef(null);
    const playButtonRef = useRef(null);
    const ctx = useRef(null);
    const pnoctx = useRef(null);

    const [lastPosition, setPosition] = useState({x:0,y:0});
    const [mouseDown, setMouseDown] = useState(false);
    const num_bins = 101;
    const [xs, setXs] = useState([...Array(num_bins).keys()].map(i => i*5 + 0))
    const [ys, setYs] = useState([...Array(num_bins).keys()].map(i => NaN))
    const [cos, setCos] = useState([])
    const [interp, setInterp] = useState([])
    const [numComponents, setNumComponents] = useState(4)
    const [complete, setComplete] = useState(true)
    const [pianoRoll, setPianoRoll] = useState([]);
    const [visualizer, setVisualizer] = useState({});
    const [playText,setPlayText] = useState("▶️ Play")
    const [playerReady, setPlayerReady] = useState(false)
    const [genReady, setGenReady] = useState(false);
    const [player, setPlayer] = useState({});
    const [players, setPlayers] = useState({});
    const [notes, setNotes] = useState(EMPTY)
    const [loading, setLoading] = useState(false)
    const [emptyGen, setEmptyGen] = useState(false)

    const FULL_TWINKLE = {notes: [
            {pitch: 60, startTime: 0, endTime: 0.5, program: 0},
            {pitch: 60, startTime: 0.5, endTime: 1, program: 0},
            {pitch: 67, startTime: 1, endTime: 1.5, program: 0},
            {pitch: 67, startTime: 1.5, endTime: 2, program: 0},
            {pitch: 69, startTime: 2, endTime: 2.5, program: 0},
            {pitch: 69, startTime: 2.5, endTime: 3, program: 0},
            {pitch: 67, startTime: 3, endTime: 4, program: 0},
            {pitch: 65, startTime: 4, endTime: 4.5, program: 0},
            {pitch: 65, startTime: 4.5, endTime: 5, program: 0},
            {pitch: 64, startTime: 5, endTime: 5.5, program: 0},
            {pitch: 64, startTime: 5.5, endTime: 6, program: 0},
            {pitch: 62, startTime: 6, endTime: 6.5, program: 0},
            {pitch: 62, startTime: 6.5, endTime: 7, program: 0},
            {pitch: 60, startTime: 7, endTime: 8, program: 0},
            {pitch: 67, startTime: 8, endTime: 8.5, program: 0},
            {pitch: 67, startTime: 8.5, endTime: 9, program: 0},
            {pitch: 65, startTime: 9, endTime: 9.5, program: 0},
            {pitch: 65, startTime: 9.5, endTime: 10, program: 0},
            {pitch: 64, startTime: 10, endTime: 10.5, program: 0},
            {pitch: 64, startTime: 10.5, endTime: 11, program: 0},
            {pitch: 62, startTime: 11, endTime: 12, program: 0},
            {pitch: 67, startTime: 12, endTime: 12.5, program: 0},
            {pitch: 67, startTime: 12.5, endTime: 13, program: 0},
            {pitch: 65, startTime: 13, endTime: 13.5, program: 0},
            {pitch: 65, startTime: 13.5, endTime: 14, program: 0},
            {pitch: 64, startTime: 14, endTime: 14.5, program: 0},
            {pitch: 64, startTime: 14.5, endTime: 15, program: 0},
            {pitch: 62, startTime: 15, endTime: 16, program: 0},
            {pitch: 60, startTime: 16, endTime: 16.5, program: 0},
            {pitch: 60, startTime: 16.5, endTime: 17, program: 0},
            {pitch: 67, startTime: 17, endTime: 17.5, program: 0},
            {pitch: 67, startTime: 17.5, endTime: 18, program: 0},
            {pitch: 69, startTime: 18, endTime: 18.5, program: 0},
            {pitch: 69, startTime: 18.5, endTime: 19, program: 0},
            {pitch: 67, startTime: 19, endTime: 20, program: 0},
            {pitch: 65, startTime: 20, endTime: 20.5, program: 0},
            {pitch: 65, startTime: 20.5, endTime: 21, program: 0},
            {pitch: 64, startTime: 21, endTime: 21.5, program: 0},
            {pitch: 64, startTime: 21.5, endTime: 22, program: 0},
            {pitch: 62, startTime: 22, endTime: 22.5, program: 0},
            {pitch: 62, startTime: 22.5, endTime: 23, program: 0},
            {pitch: 60, startTime: 23, endTime: 24, program: 0}
        ],
        totalTime: 24
    };




    var drawline = function() {
        ctx.current.beginPath();
        for (let i = 0; i < num_bins+1; i++) {
            ctx.current.clearRect(0,0,600,200);
            ctx.current.lineTo(xs[i],ys[i]);
            ctx.current.stroke();
        }
    };

    const draw = useCallback((x,y,xs,ys) => {
        if (!mouseDown) {
            return
        }
            ctx.current.beginPath();
            for (let i = 0; i < num_bins+1; i++) {
                ctx.current.clearRect(0,0,ctx.current.canvas.width, ctx.current.canvas.height);
                ctx.current.lineTo(xs[i],ys[i]);
                ctx.current.stroke();
            // ctx.current.moveTo(lastPosition.x,lastPosition.y);
            // ctx.current.lineTo(x,y);
            // ctx.current.closePath();
            // ctx.current.stroke();
            setPosition({x,y})
        }
    }, [lastPosition, mouseDown, setPosition]);

    useEffect(() => {
        const canvas = drawRef.current;
        canvas.width = canvasWidth*2;
        canvas.height = canvasHeight*2;
        canvas.style.width = `${canvasWidth}px`
        canvas.style.height = `${canvasHeight}px`
        if (drawRef.current) {
            ctx.current = drawRef.current.getContext('2d');
            ctx.current.scale(2,2)
            ctx.current.lineWidth='5';
            ctx.current.strokeStyle='white';
            ctx.current.lineCap='round';
        }
    }, []);

    useEffect(() => {
        const roll = rollRef.current;
        roll.width = canvasWidth*2;
        roll.height = canvasHeight*2;
        roll.style.width = `${canvasWidth}px`
        roll.style.height = `${canvasHeight}px`
        pnoctx.current = roll.getContext('2d');
        pnoctx.current.scale(2,2)
        setPianoRoll(document.getElementById('pnoid'))
    }, []);

    const onMouseDown = (e) => {
        setMouseDown(true)
    }

    const onMouseUp = (e) => {
        setMouseDown(false)
    }

    const onMouseMove = (e) => {
        if (mouseDown) {
            ys[Math.floor(e.nativeEvent.offsetX / 5)] = e.nativeEvent.offsetY;
        }
        draw(e.nativeEvent.offsetX, e.nativeEvent.offsetY,xs,ys);
    }

    const onTouchStart = (e) => {
        setMouseDown(true)
    }

    const onTouchMove = (e) => {
        if (mouseDown) {
            var y = e.nativeEvent.touches[0].pageY - drawRef.current.offsetTop;
            var x = e.nativeEvent.touches[0].pageX - drawRef.current.offsetLeft;
            ys[Math.floor(x/5)] = y;
        }
        if (x > canvasWidth || x < 0 || y > canvasHeight || y < 0 ) {
            onTouchCancel()
        }
        draw(x,y,xs,ys);
    }

    const onTouchCancel = (e) => {
        setMouseDown(false);
    }

    const clear = () => {
        ctx.current.clearRect(0,0,ctx.current.canvas.width, ctx.current.canvas.height);
        setYs([...Array(num_bins).keys()].map(i => NaN));
        setCos([NaN])
        setInterp([NaN])
        setEmptyGen(false)
        if (player.isPlaying()){
            stopPlayer();
        }
        let vis = new mm.PianoRollCanvasVisualizer(EMPTY, pianoRoll, {
            noteRGB: '255, 255, 255',
            activeNoteRGB: '232, 69, 164',
            pixelsPerTimeStep: 500/8,
        });
        setVisualizer(vis);
        setPlayerReady(false);
    }

    const getVisualizer = () => {
        if (player.isPlaying()){
            stopPlayer();
        }
        let vis = new mm.PianoRollCanvasVisualizer(notes, pianoRoll, {
            noteRGB: '255, 255, 255',
            activeNoteRGB: '232, 69, 164',
            pixelsPerTimeStep: 500/8,
        });
        setVisualizer(vis);
        setPlayerReady(true);
    }

    const clickCosine = () => {
        getCosine(numComponents,true);
    }

    const getData = async (query) => {
        return API.get(myAPI, path, query)
    }

   useEffect(() => {
       if (!genReady) {
           return
       }
        getVisualizer()
        setGenReady(false)
    }, [notes,genReady])

    const getCosine = (val, redraw) => {
        if (!ys.some(isFinite)) {
            setEmptyGen(true)
            return;
        }
        setEmptyGen(false)
        if (complete) {
            setComplete(false);
            let invYs = ys.map(y => (200-y)*14/200);
            let query = { // OPTIONAL
                headers: {}, // OPTIONAL
                response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
                queryStringParameters: {  // OPTIONAL
                    canvas: invYs.toString(),
                    components: val,
                    generate: redraw
                },
            };
            if (redraw) {
                setLoading(true)
            }
            API.get(myAPI, path, query)
                .then(response => {
                    console.log(query.queryStringParameters)
                    console.log(response.data)
                    setCos(response.data.cosine)
                    setInterp(response.data.interpolated)
                    if (redraw) {
                        setNotes(response.data.noteSequence)
                        setGenReady(true)
                    }
                    setComplete(true)
                    setLoading(false)
                })
                .catch(error => {
                    console.log(error)
                })

        }
    }

    const getStaticValue=(e,val)=>{
        setNumComponents(val);
        getCosine(val,false);
    }

    const getValue=(e,val)=>{
        if (val!==numComponents) {
            setNumComponents(val);
            getCosine(val,false);
        }
    }


    const seekClick=(e)=>{
        if (!player.isPlaying()) {
            return
        }
        var w = pnoctx.current.canvas.width/2
        var end = visualizer.noteSequence.notes[visualizer.noteSequence.notes.length - 1].endTime
        player.seekTo((e.nativeEvent.offsetX-10)/w*end);
    }

    const seekTouch=(e)=>{
        if (!player.isPlaying()) {
            return
        }
        var touch = e.nativeEvent.touches[0].pageX - rollRef.current.offsetLeft
        var w = pnoctx.current.canvas.width/2
        var end = visualizer.noteSequence.notes[visualizer.noteSequence.notes.length - 1].endTime
        player.seekTo((touch-10)/w*end);
    }

    const initPlayers=(visualizer)=> {
        players.soundfont = new mm.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/salamander');
        players.soundfont.callbackObject = {
            run: (note) => {
                visualizer.redraw(note);
            },
            stop: () => {stopPlayer()}
        };
        setPlayer(players.soundfont)
    }

    const stopPlayer=()=> {
        player.stop();
        pianoRoll.classList.remove('playing');
        visualizer.redraw();
        setPlayText("▶️ Play");
    }

    const pausePlayer=()=> {
        player.pause();
        setPlayText("▶️ Resume");
    }

    const resumePlayer=()=> {
        player.resume();
        setPlayText("⏸️ Pause");
    }

    const startPlayer=()=> {
        pianoRoll.scrollLeft = 0;
        pianoRoll.classList.add('playing');
        mm.Player.tone.context.resume();
        player.start(visualizer.noteSequence);
        setPlayText("⏸️ Pause");
    }

    const play=() => {
        if (playerReady) {
            if (player.isPlaying()) {
                if (player.getPlayState() !== 'paused') {
                    pausePlayer();
                } else {
                    resumePlayer();
                }
            } else {
                startPlayer();
            }
        }
    };

    const downloadMidi=()=>{
        let seq = visualizer.noteSequence;
        seq.notes.forEach(n => n.velocity = 80);
        seq.controlChanges=[];
        const magentaMidi = mm.sequenceProtoToMidi(seq);
        const magentaFile = new Blob([magentaMidi], { type: 'audio/midi' })
        const magentaURL = URL.createObjectURL(magentaFile);
        window.location.assign(magentaURL);
    }

    useEffect(() => {
        // setCos([NaN]);
        // setInterp([NaN]);
        initPlayers(visualizer);
    }, [visualizer]);


    return (
        <div>
            <h1>🎹 MIDI-Draw ✍️</h1>
            <p>Draw a shape and AI will turn it into music.<br />
                <em>Tip: draw slowly to avoid spikes!</em></p>
            <canvas ref={drawRef}
                    // width={500}
                    // height={200}
                    onMouseDown={onMouseDown}
                    onMouseMove={onMouseMove}
                    onMouseUp={onMouseUp}
                    onMouseLeave={onMouseUp}
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchCancel}
                    onTouchCancel={onTouchCancel}
            />
            <div id='buttons'>
                <button onClick={clear}>🔄 &nbsp; Reset</button>
                {loading ? <CircularProgress /> : <> {emptyGen ? 'Draw something! ⬆️': <div id="loadingGap"/>}</>}
                <button onClick={clickCosine}>♪ Generate</button>
                {/*<button onClick={clickCosine}>📈 Get Contour</button>*/}
            </div>

            <div >
                <canvas id='pnoid'
                        ref={rollRef}
                        width={500}
                        height={200}
                        onMouseDown={seekClick}
                        onTouchStart={seekTouch}
                />
            </div>
            <p><em>No Sound on iOS? Try switching off silent mode!</em></p>
            <div id='buttons'>
                <button ref={playButtonRef} onClick={play}>{playText}</button>
                <button onClick={stopPlayer}>⏹ ️&nbsp; Stop</button>
                <button onClick={downloadMidi}>💾 &nbsp; Save</button>
            </div>

            <div className="Plot">
            <Plot
                data={[
                    {
                        x: xs,
                        y: interp,
                        type: 'scatter',
                        mode: 'markers',
                        marker: {color: '#282c34'},
                        name: 'Input'
                    },
                    {
                        x: xs,
                        y: cos,
                        type: 'line',
                        marker: {color: 'red'},
                        name: 'Cosine Contour'
                    },
                ]}
                // config={{responsive:true}}
                layout={{
                    width: 500,
                    height: 300,
                    // showlegend: false,
                    xaxis: {
                        showticklabels:false,
                        showgrid:false,
                        zeroline:false,
                        visible:false
                    },
                    plot_bgcolor: '#eee',
                    yaxis: {
                        showticklabels: false,
                        showgrid: false,
                        zeroline: false,
                        visible: false,
                        range: [0, 14]
                    },
                    // autosize:false,
                    margin: {
                    l: 10,
                    r: 10,
                    b: 10,
                    t: 10,
                    // pad: 10
                },
                    legend: {
                        x: 0.5,
                        y: 0,
                        yanchor: 'top',
                        xanchor: 'center'}}}
                config={{staticPlot:true}}
            />
            </div>
            <p>📈 ️&nbsp; Select number of cosine components ({numComponents})️ &nbsp; ⬇️</p>
            <div id='sliderStyle'>
                <StyledEngineProvider injectFirst>
                    <Slider className="slider" value={numComponents} min={1} max={50} onChange={getStaticValue}  aria-label="Number of Cosine Components" valueLabelDisplay="auto" />
                </StyledEngineProvider>
                {/*onChangeCommitted={getStaticValue}*/}
            </div>
            {/*<p>{cos}</p>*/}
        </div>
    );
}

